<template>
<div>
    <div class="content-gridless" v-if="this.accountName === null">
        <div class="container ">
            <div class="row align-items-center fill">
                <div class="col align-self-center">
                    <div class="card card-block p-1">
                        <h1 class="m-1 text-center text-muted">
                            <br> Bitte im Menü ein Konto auswählen <br> <br>
                        </h1>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <div class="content scrollable" v-if="this.accountName !== null">
        <div style="grid-area: messages; padding: 0.5rem">
            <div v-for="(msg, index) in messages" v-bind:key="index"
                class="alert alert-dismissible"
                :class="{
                    'alert-info': msg.type == 'INFO',
                    'alert-danger': msg.type == 'ERROR'}">
                <a href="#" @click="closeMessage(index)" class="close" aria-label="close">&times;</a>
                {{ msg.message }}
            </div>
        </div>
        <div style="grid-area: tabs">
            
            <h5 class="p-2 text-primary">Konto: {{accountName}}</h5>
            
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li v-for="(editor, index) in editors" v-bind:key="index" class="nav-item" >
                    <div
                        class="nav-link p-2"
                        :class="{active: editor.isActive, 'pr-1': index > 0}"
                    >
                        <a 
                            class="" style="display: inline-block !important; text-decoration: none;"
                            @click="switchTab(index)"
                            id=""
                            data-toggle="tab"
                            href="#"
                            role="tab"
                            aria-controls="contact"
                            :aria-selected="editor.isActive"
                        >
                            {{ editor.name }}
                        </a>
                        <button
                            v-if="index > 1"
                            :key="editor"
                            @click.prevent="deleteThisTab(editors.indexOf(editor))"
                            type="button"
                            class="close pl-2 pr-2"
                            aria-label="Close Tab"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </li>
            </ul>
        </div>

        <div class="tab-content pr-4" id="myTabContent">
            <div
                v-for="(editor, index) in editors"
                v-bind:key="editor"
                class="tab-pane fade"
                :class="{show: editor.isActive, active: editor.isActive}"
                :id="index"
                role="tabpanel"
                aria-labelledby="post-payable-tab"
            >
                <component
                    :is="editor.type"
                    :key="editor"
                    v-bind:editor_data="editor.data"
                    v-on:delete-tab="deleteThisTab(index)"
                ></component>
            </div>
        </div>
        
        <div class="table-striped table-bordered pr-4 content-bottom" style="grid-area: table-pane; padding: 5px">
            <div class="form-row mb-3" >
                <label for="fromDate" class="col-sm-1 col-form-label col-form-label-sm">
                    Startdatum
                </label>
                <div class="col-sm-2">
                    <datepicker
                        format="yyyy-MM-dd"
                        v-model="t_date_from"
                        input-class="form-control form-control-sm"
                        :language="de"
                        :monday-first=true
                        id="fromDate"
                        :disabled-dates="{from: t_date_to}"
                        @keydown.enter.prevent
                    >
                    </datepicker>
                </div>
            
                <label for="toDate" class="col-sm-1 col-form-label col-form-label-sm">
                    Enddatum
                </label>
                <div class="col-sm-2">
                    <datepicker
                        format="yyyy-MM-dd"
                        v-model="t_date_to"
                        input-class="form-control form-control-sm"
                        :language="de"
                        :monday-first=true
                        id="toDate"
                        :disabled-dates="{from: new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                new Date().getDate()+1
                            ), to: t_date_from}"
                        @keydown.enter.prevent
                    >
                    </datepicker>
                </div>
                <div class="col-sm-4">

                </div>
                <div class="col-sm-2 d-flex justify-content-end">
                    <div class="form">
                        <button v-on:click="downloadCountingReport()" v-on:submit.prevent="onSubmit" class="btn btn-primary">
                            Zählprotokoll
                        </button>
                    </div>
                </div>
            </div>
            <table class="table table-sm table-hover" style="max-height: 100%; overflow: auto;" id="entries">
                <thead class="thead-light">
                    <tr>
                        <!--<th>#</th>-->
                        <th style="min-width: 60px;"><a href="#" @click="switchSorter(byIdSorter)">ID
                            <i v-if="current_sorter == byIdSorter && reversed" class="fas fa-sort-amount-up-alt fa-fw fa-md text-secondary"></i>
                            <i v-if="current_sorter == byIdSorter && !reversed" class="fas fa-sort-amount-down-alt fa-fw fa-md text-secondary"></i>
                        </a></th>
                        <th style="min-width: 95px;"><a href="#" @click="switchSorter(byDateSorter)">Datum
                            <i v-if="current_sorter == byDateSorter && reversed" class="fas fa-sort-amount-up-alt fa-fw fa-md text-secondary"></i>
                            <i v-if="current_sorter == byDateSorter && !reversed" class="fas fa-sort-amount-down-alt fa-fw fa-md text-secondary"></i>
                        </a></th>
                        <th><a href="#" @click="switchSorter(byTextSorter)">Vorgang
                            <i v-if="current_sorter == byTextSorter && !reversed" class="fas fa-sort-amount-up-alt fa-fw fa-md text-secondary"></i>
                            <i v-if="current_sorter == byTextSorter && reversed" class="fas fa-sort-amount-down-alt fa-fw fa-md text-secondary"></i>
                        </a></th>
                        <!--<th>Kostenstelle</th>-->
                        <th style="min-width: 140px;"><a href="#" @click="switchSorter(byReceiptInfoSorter)">Kassenan.-Nr
                            <i v-if="current_sorter == byReceiptInfoSorter && reversed" class="fas fa-sort-amount-up-alt fa-fw fa-md text-secondary"></i>
                            <i v-if="current_sorter == byReceiptInfoSorter && !reversed" class="fas fa-sort-amount-down-alt fa-fw fa-md text-secondary"></i>
                        </a></th>
                        <th>Eingang</th>
                        <th>Ausgang</th>
                        <th>Saldo</th>
                        <th class="fit"></th>
                    </tr>
                </thead>
                <tbody>
                    <!--<tr v-for="entry in accountInfo.entries.slice().reverse()" v-bind:key="entry.id">-->
                    <tr v-if="!this.reversed">
                        <td colspan="6" style="text-align: center"><i>Übertrag</i></td>
                        <td style="text-align: right">{{ computeValue(carryBalance) }}</td>
                        <td></td>
                    </tr>
                    <EntryRow
                        v-for="entry in processedEntries"
                        :key="entry.id"
                        :accountName="accountName"
                        :ownGroup="ownGroup"
                        :entry="entry"
                        @change-receipt-info="(entry) => changeReceiptInfo(entry)"
                        @download-receipt="(id) => downloadReceipt(id)"
                        @download-document="(id) => downloadDocument(id)"
                        @reverse-transaction="(entry) => reverseTransaction(entry)">
                    </EntryRow>
                    <tr v-if="this.reversed">
                        <td colspan="6" style="text-align: center"><i>Übertrag</i></td>
                        <td style="text-align: right">{{ computeValue(carryBalance) }}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
  
</template>

<script>
import BookReverseEntry from './BookReverseEntry.vue';
import BookEntry from './BookEntry.vue';
import Reports from './Reports.vue';
import EntryRow from './EntryRow.vue';
import axios from "axios";
import Datepicker from 'vuejs-datepicker';
import ChangeReceiptInfo from './ChangeReceiptInfo.vue';
import {en, de} from 'vuejs-datepicker/dist/locale';

const api_url = process.env.VUE_APP_ROOT_API;

function cleanId(id) {
    if (Array.isArray(id)) {
        return id[1];
    }
}

export default {
    name: 'Content',
    components: {
        BookReverseEntry, BookEntry, Datepicker, EntryRow
    },
    data() {
        return {
            account: 'Default',
            error_msg: 'No Error',
            editors: [],
            entries: [],
            current_tab: 0,
            reversed: true,
            en: en,
            de: de,
            t_date_from: new Date(new Date().getFullYear(), 0, 1),
            t_date_to: new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate(),
                23, 59, 59, 999
            ),
            byDateSorter: function(e1, e2) {
                var days1 = Date.parse(e1.date) / (1000*60*60*24)
                var days2 = Date.parse(e2.date) / (1000*60*60*24)
                if (Math.abs(days1 - days2) < 0.9999) {
                    var id1 = parseInt(cleanId(e1.id))
                    var id2 = parseInt(cleanId(e2.id))
                    return id1 - id2
                }
                return days1 - days2
            },
            byReceiptInfoSorter: function(e1, e2) {
                if(e1.receiptInfo < e2.receiptInfo) return -1;
                if(e1.receiptInfo > e2.receiptInfo) return 1;
                return 0;
            },
            byTextSorter: function(e1, e2) {
                if(e1.text.toUpperCase() > e2.text.toUpperCase()) return -1;
                if(e1.text.toUpperCase() < e2.text.toUpperCase()) return 1;
                return 0;
            },
            byIdSorter: function(e1, e2) {
                var id1 = parseInt(cleanId(e1.id))
                var id2 = parseInt(cleanId(e2.id))
                return id1 - id2
            },
            current_sorter: this.byDateSorter,
        }
    },
    methods: {
        reloadEntries: function(account_info) {
            this.entries = []
            // eslint-disable-next-line
            console.log("Process entries: " + account_info.entries.length)
            var entries = account_info.entries.slice().filter(
                e => {
                    var e_date = Date.parse(e.date);
                    return (this.t_date_from <= e_date) && (e_date <= this.t_date_to);
                });
            if (this.reversed) {
                // eslint-disable-next-line
                console.log("Process entries: Finished reversed")
                entries = entries.slice().sort(this.current_sorter).reverse();
            } else {
                entries = entries.slice().sort(this.current_sorter);
            }
            entries.slice().forEach(e => {
                // eslint-disable-next-line
                this.entries.push(Object.freeze(e));
            })
            // eslint-disable-next-line
            console.log("Process entries: Finished")
        },
        loadInitialData: function() {
            if (this.accountName === null) {
                //return;
            }
            //this.$store.commit('switch_account', 'Handkasse')
            this.$store.dispatch('loadData')
            //this.$store.commit('switch_account', this.$store.state.acc_list.accounts[0].accounts[0].name)
           
            //this.$store.commit('switch_account', 'FSR 1 Handkasse')

            this.editors.push({
                type: BookEntry,
                name: "Einfache Buchung",
                isActive: true,
                data: {
                    t_text: "Test"
                }
            })
            this.editors.push({
                type: Reports,
                name: "Berichte",
                isActive: false,
                data: {
                    reports: [{last_modified: '2019-11-16 10:44:12',
                            filename: "test.odt"}]
                }
            })
        },
        switchTab: function(tab_index) {
            this.current_tab = tab_index
            this.editors.forEach(editor => {
                editor.isActive = false
            });
            //console.log(tab_index)
            this.editors[tab_index].isActive = true
        },
        deleteThisTab: function(tab_index) {
            this.editors.splice(tab_index, 1)
            if (tab_index  === 2) {
                this.switchTab(0);
                return;
            }
            var switch_index = 0
            if (tab_index == this.current_tab) {
                if (tab_index == this.editors.length)
                    switch_index = tab_index - 1
                else
                    switch_index = tab_index
                this.switchTab(switch_index)
            }
            
        },
        computeValue: function(amount) {
            var num = new Number(amount / 100);
            return parseFloat(Math.round(num * 100) / 100)
                .toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        },
        computeValue2: function(amount) {
            var num = new Number(amount / 100);
            return parseFloat(Math.round(num * 100) / 100)
                .toFixed(2)
                .toString()
                .replace('.', ',');
        },
        closeMessage: function(msg) {
            this.$store.commit('remove_message', msg)
        },
        reverseTransaction: function(entry) {
            var editor_data = {
                t_text: entry.text,
                t_counterAcc: entry.counter_acc,
                t_amount: this.computeValue2(entry.tx_amount + entry.rx_amount).replace(',', '.'),
                t_transaction_id: entry.id,
                t_action_type: entry.tx_amount == 0 ? "INPUT" : "OUTPUT",
                t_receiptInfo: entry.receiptInfo,
                t_txAcc: entry.txAcc,
                t_rxAcc: entry.rxAcc,
                t_date: entry.date
            }
            var i = this.editors.push({
                type: BookReverseEntry,
                name: "Stornieren",
                isActive: false,
                data: editor_data
            })
            this.switchTab(i-1)
        },
        changeReceiptInfo(entry) {
            var editor_data = {
                t_text: entry.text,
                t_counterAcc: entry.counter_acc,
                t_amount: this.computeValue2(entry.tx_amount + entry.rx_amount).replace(',', '.'),
                t_transaction_id: entry.id,
                t_action_type: entry.tx_amount == 0 ? "INPUT" : "OUTPUT",
                t_receiptInfo: entry.receiptInfo,
                t_txAcc: entry.txAcc,
                t_rxAcc: entry.rxAcc,
                t_date: entry.date
            }
            var i = this.editors.push({
                type: ChangeReceiptInfo,
                name: "Transaktion bearbeiten",
                isActive: false,
                data: editor_data
            })
            this.switchTab(i-1)
        },
        downloadDocument(id) {
            var clean_id = this.$filters.cleanId(id)
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            axios({
                url: api_url + "/documents/" + this.accountName + "/" + id,
                method: 'GET',
                responseType: 'blob', // important,
                auth: credentials,
                headers: {
                    'Cache-Control': 'no-cache'
                }
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'kassenanordnung.odt'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        downloadReceipt(id) {
            var clean_id = this.$filters.cleanId(id)
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            axios({
                url: api_url + "/receipts/" + this.accountName + "/" + id,
                method: 'GET',
                responseType: 'blob', // important,
                auth: credentials
            })
            .catch(e => {
                // eslint-disable-next-line
                console.log(e);
                var msg = {
                    type: "ERROR",
                    message: "Belege nicht vorhanden!"
                }
                // eslint-disable-next-line
                console.log("Pushing error")
                this.$store.commit('add_message', msg)
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                if (response.headers['content-type'] == "application/pdf") {
                    link.setAttribute('download', 'beleg.pdf');
                } else {
                    link.setAttribute('download', 'beleg.zip');
                }
                document.body.appendChild(link);
                link.click();
            });
        },
        downloadCountingReport() {
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            axios({
                url: api_url + "/countingReports/" + this.accountName,
                method: 'GET',
                responseType: 'blob', // important,
                auth: credentials
            })
            .catch(e => {
                // eslint-disable-next-line
                console.log(e);
                var msg = {
                    type: "ERROR",
                    message: "Fehler beim Abrufen des Zählprotokolls"
                }
                // eslint-disable-next-line
                console.log("Pushing error")
                this.$store.commit('add_message', msg)
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Zaehlprotokoll.ods'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        switchSorter(sorter) {
            if (this.current_sorter == sorter) {
                this.reversed = !this.reversed
            } else {
                this.reversed = true
                this.current_sorter = sorter
            }
        }
    },
    computed: {
        accountName () {
            if (this.$store.state.account_info) {
                return this.$store.state.current_acc
            } else {
                return null
            }
        },
        accountInfo() {
            return this.$store.state.account_info;
        },
        sortedEntries() {
            if (this.reversed) {
                return this.accountInfo.entries.slice().sort(this.current_sorter).reverse()
            }
            return this.accountInfo.entries.slice().sort(this.current_sorter)
        },
        carryBalance() {
            var entries = this.accountInfo.entries.slice().filter(
                e => Date.parse(e.date) < this.t_date_from);
            entries = entries.sort(this.byDateSorter);
            if (entries.length == 0) {
                return 0;
            }
            return entries[entries.length - 1].balance;
        },
        processedEntries() {
            // eslint-disable-next-line
            console.log("Process entries: " + this.accountInfo.entries.length)
            var entries = this.accountInfo.entries.slice().filter(
                e => {
                    var e_date = Date.parse(e.date);
                    return (this.t_date_from <= e_date) && (e_date <= this.t_date_to);
                });
            if (this.reversed) {
                entries = entries.slice().sort(this.current_sorter).reverse();
            } else {
                entries = entries.slice().sort(this.current_sorter);
            }
            // eslint-disable-next-line
            console.log("Process entries: Finished")
            return Object.freeze(entries);
        },
        messages() {
            return this.$store.state.messages;
        },
        ownGroup() {
            // eslint-disable-next-line
            console.log("this.$store.state.remote");
            // eslint-disable-next-line
            console.log(this.$store.state.remote);
            if (this.$store.state.remote === null) {
                return ""
            }
            return this.$store.state.remote.ownGroup
        }
    },
    beforeMount() {
        this.loadInitialData();
        this.current_sorter = this.byDateSorter;
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td.fit, 
    .table th.fit {
        /*white-space: nowrap;*/
        width: 1%;
    }
    .scrollable {
        overflow-y: auto;
        max-height: 100%;
    }
    .fill { 
        min-height: 100%;
        height: 100%;
    }
    .vcenter {
        margin-top: auto;
        margin-bottom: auto;
    }

</style>
